import { useRouter } from "next/router";
import React from "react";

import { Box, Flex, Image, Skeleton, Text } from "@chakra-ui/react";
import { useDispatch } from "react-redux";

import { addToCart } from "../../redux/actions";
import Button from "../common/button";

import { trackAddToCart } from "../../utils/analytics";
import IsDoctor from "../permission/isDoctor";

const index = ({ product, cartProductIds }) => {
  const router = useRouter();
  const dispatch = useDispatch();

  const {
    id,
    slug,
    images,
    name,
    doctor_price,
    in_stock,
    regular_price,
    old_price,
  } = product;

  const inCart = cartProductIds?.includes(id);

  const image = images[0];

  return (
    <>
      <Flex
        mb="15px"
        shadow="lg"
        flexWrap="wrap"
        maxWidth="400px"
        borderWidth="0px"
        overflow="hidden"
        borderRadius="5px"
        alignItems="center"
        height="fit-content"
        justifyContent="center"
        width={{
          base: "90%",
          md: "340px",
          lg: "400px",
          xl: "340px",
          "2xl": "400px",
        }}
      >
        <Box
          position="relative"
          width="100%"
          height="100%"
          maxHeight="400px"
          overflow="hidden"
          _hover={{ cursor: "pointer" }}
          onClick={() => router.push(`/product/${slug}`)}
        >
          <Image
            lazy="true"
            width="100%"
            height="100%"
            maxHeight="400px"
            src={image?.src}
            alt={image?.name}
            objectFit="contain"
            fallback={<Skeleton w="100%" height="100%" maxHeight="400px" />}
          />
        </Box>

        <Box p="20.5px" width="100%">
          <Flex alignItems="baseline">
            <Text
              _hover={{ cursor: "pointer" }}
              variant="productCardTitle"
              onClick={() => router.push(`/product/${slug}`)}
            >
              {name}
            </Text>
            {!in_stock && (
              <Text
                ml="3"
                fontSize="12"
                variant="priceText"
                borderColor="maroon"
              >
                Out of stock
              </Text>
            )}
          </Flex>
          {/* <Box
            mt="5px"
            mb="15px"
            noOfLines={2}
            flexWrap="wrap"
            fontWeight="400"
            fontSize="16px"
            fontFamily="Lato"
            color="detailsColor"
          >
            {short_description && parse(short_description)}
          </Box> */}
          <Box mt="5px" width="100%" d="flex" alignItems="center">
            <Button
              py="10px"
              width="165px"
              px={{ base: "15px", sm: "20.5px" }}
              color={inCart ? "maroon" : "white"}
              backgroundColor={inCart ? "grey" : "maroon"}
              title={inCart ? "Added to cart" : "Add to cart"}
              handleClick={() => {
                trackAddToCart(product);
                if (!in_stock) {
                  alert("Product is out of stock!");
                } else {
                  dispatch(addToCart(product));
                }
              }}
            />
            {IsDoctor() ? (
              <>
                <Text
                  as="s"
                  ml="5px"
                  variant="priceText"
                  color="titleColor"
                  display={{ base: "none", sm: "block" }}
                >
                  ₹{parseFloat(regular_price).toFixed(2)}
                </Text>
                <Text ml={{ base: "10px", sm: "3px" }} variant="priceText">
                  ₹{parseFloat(doctor_price).toFixed(2)}
                </Text>
              </>
            ) : (
              <Text ml="10px" variant="priceText">
                ₹{parseFloat(regular_price).toFixed(2)}
              </Text>
            )}
          </Box>
        </Box>
      </Flex>
    </>
  );
};

export default index;
